module.exports = __webpack_public_path__ + "img/memory.db2a6b8f.png";